import moment from 'moment-timezone';

export function isWithinUpdatedHours(
  firmwareUpdateAvailableHours: string,
  isFirmwareUpdateAvailableWeekdays: string
): boolean {
  const firmwareUpdateAvailableWeekdaysArr = isFirmwareUpdateAvailableWeekdays.split(',');
  const supportedHours = {};
  firmwareUpdateAvailableWeekdaysArr.forEach(
    (day) => (supportedHours[day] = firmwareUpdateAvailableHours)
  );
  const localTimeGerman = moment.tz(moment().toDate(), 'Europe/Berlin');
  const todayGermanWeekday = moment.tz(moment().toDate(), 'Europe/Berlin').format('dddd');

  const availableHoursToday = supportedHours[todayGermanWeekday]
    ? supportedHours[todayGermanWeekday].split('-')
    : null;

  if (!availableHoursToday) {
    return false;
  }

  const availableStartHour = availableHoursToday[0];
  const availableEndHour = availableHoursToday[1];

  if (availableStartHour?.length > 1 && availableEndHour?.length > 1) {
    return localTimeGerman.isBetween(
      moment(availableStartHour, 'h:mm'),
      moment(availableEndHour, 'h:mm')
    );
  }
}
